import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileName',
    standalone: true
})
export class FileNamePipe implements PipeTransform {
    transform(value: string): string {
        const arr = value.split('.');
        arr.pop();
        return arr.join('.') ?? '';
    }
}
